import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import PageSizeSelector from '../../../../presentation/PageSizeSelector';
import PagePositionLabel from '../../../../presentation/PagePositionLabel';
import Pagination from '../../../../presentation/Pagination';
import NoSearchResults from '../../../../presentation/NoSearchResults';

import ReactGrid,
{
  ReactGridHeader,
  ReactGridColumn,
  ReactGridBody,
  ReactGridRowTemplate,
  ReactGridReadOnlyCell,
  ReactGridNoRowsTemplate
} from '../../../../presentation/ReactGrid';

class WholesaleNumbers extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      row: props.row === undefined ? {} : props.row,
      dataSource: [],
      resporgs: [],
      numberFilter: '',
      pageSize: 25,
      pageIndex: 0,
    };

    this.onHandleChange = this.onHandleChange.bind( this );
    this.onHandleClickSearch = this.onHandleClickSearch.bind( this );
    this.onHandleKeyDown = this.onHandleKeyDown.bind( this );
    this.onPageSizeChanged = this.onPageSizeChanged.bind( this );
    this.onPageChanged = this.onPageChanged.bind( this );
    this.onHandleException = this.onHandleException.bind( this );

    this.title = 'Wholesale Numbers';
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alert = new Alerts( this.props.bugsnag, this.props.dispatch );

    this.getData();
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  getData() {
    const row = { ...this.state.row };
    const numberParams = [
      { Company_ID: row.Company_ID }
    ];
    const resporgParams = [
      { WS_Company_ID: row.Company_ID }
    ];

    const all = () => Promise.all( [
      this.getWholesaleNumbers( numberParams ),
      this.getResporgs( resporgParams )
    ] ).then( ( [numberResults, resporgResults] ) => {
      this.setState( {
        dataSource: numberResults,
        resporgs: resporgResults
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    all();
  }

  getResporgs( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/resporgs' );

      api.get( params ).then( ( resporgResults ) => {
        resolve( resporgResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getWholesaleNumbers( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/numbers' );

      api.get( params ).then( ( numberResults ) => {
        resolve( numberResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }


  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  onHandleChange( e ) {
    this.setState( {
      [e.target.name]: e.target.value
    } );
  }

  onHandleClickSearch( e ) {
    const params = [
      { Company_ID: this.state.row.Company_ID },
      { numdialed: this.state.numberFilter }
    ];

    this.getWholesaleNumbers( params ).then( ( numberResults ) => {
      this.setState( {
        dataSource: numberResults
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onHandleKeyDown( e ) {
    if ( e.key === 'Enter' ) {
      this.onHandleClickSearch();
    }
  }

  onPageSizeChanged( pageSize ) {
    this.setState( {
      pageSize: pageSize
    } );
  }

  onPageChanged( page, e ) {
    this.setState( {
      pageIndex: page.index
    } );
  }

  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/

  getPageSizeOptions() {
    let options = [];
    const dataSource = this.state.dataSource;

    if ( dataSource === undefined ) {
      return options;
    }

    if ( dataSource === null ) {
      return options;
    }

    if ( dataSource.length >= 25 ) {
      options.push( { value: 25, selected: true } );
    }

    if ( dataSource.length >= 50 ) {
      options.push( { value: 50, selected: false } );
    }

    if ( dataSource.length >= 75 ) {
      options.push( { value: 75, selected: false } );
    }

    if ( dataSource.length >= 100 ) {
      options.push( { value: 100, selected: false } );
    }

    if ( dataSource.length >= 500 ) {
      options.push( { value: 500, selected: false } );
    }

    if ( dataSource.length >= 1000 ) {
      options.push( { value: 1000, selected: false } );
    }

    return options;
  }

  /****************************************************************************
   * STYLING
   ***************************************************************************/

  getDialogContentStyle() {
    return {
      display: 'grid',
      gridTemplateRows: '570px 50px',
      width: '100%',
      height: '620px'
    };
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  renderPageSizeSelector() {
    let pageSizeSelectorControl = null;

    if ( this.state.dataSource !== undefined ) {
      if ( this.state.dataSource.length > 0 ) {
        if ( this.state.dataSource.length >= this.state.pageSize ) {
          pageSizeSelectorControl = (
            <PageSizeSelector options={this.getPageSizeOptions()} onPageSizeChanged={this.onPageSizeChanged} />
          );
        }
      }
    }

    return pageSizeSelectorControl;
  }

  renderPagination() {
    const pageSize = this.state.pageSize;
    const pageStart = ( parseInt( this.state.pageIndex, 10 ) * parseInt( pageSize, 10 ) ) + 1;
    const pageEnd = pageStart + parseInt( pageSize, 10 ) - 1;
    const pageTotal = this.state.dataSource === undefined ? 0 : this.state.dataSource.length;

    return (
      <span className='dialog-footer-content-pagination'>
        <span className='dialog-footer-content-pagination-cell-1'>
          <PagePositionLabel pagesize={pageSize} pagestart={pageStart} pageend={pageEnd} pagetotal={pageTotal} />
        </span>
        <span className='dialog-footer-content-pagination-cell-2'>
        </span>
        <span className='dialog-footer-content-pagination-cell-3'>
          <Pagination pageindex={this.state.pageIndex} totalitems={pageTotal} maxitemsperpage={this.state.pageSize} maxpages={6} onPageChanged={this.onPageChanged} />
        </span>
      </span>
    );
  }

  render() {
    return (
      <span>
        <span className='wholesale-dialog-header-content'>
          <span className='wholesale-dialog-search-content'>
            <label className='wholesale-dialog-search-label'>Search Number (Use % as needed)</label>
            <input className='wholesale-dialog-search-input' name='numberFilter' type="text" onChange={this.onHandleChange} onKeyDown={this.onHandleKeyDown} />
            <button className='dialog-save-button' style={{ height: '32px', marginRight: 0 }} onClick={this.onHandleClickSearch}>Search</button>
          </span>
          {
            this.renderPageSizeSelector()
          }
        </span>
        <span style={this.getDialogContentStyle()}>
          <ReactGrid
            tagName='grid'
            dataSource={this.state.dataSource}
            height='auto'
            width='auto'
            paging={true}
            pageSize={this.state.pageSize}
            pageIndex={this.state.pageIndex}
          >
            <ReactGridHeader
              tagName='header'
            >
              <ReactGridColumn
                tagName='column'
                caption='Company'
                width='200px'
                sorted='Company'
                dataType='string'
                index={0}
              />
              <ReactGridColumn
                tagName='column'
                caption='Batch #'
                width='75px'
                sorted='batch'
                dataType='string'
                index={1}
              />
              <ReactGridColumn
                tagName='column'
                caption='Number'
                width='200px'
                sorted='numdialed'
                dataType='string'
                index={2}
              />
              <ReactGridColumn
                tagName='column'
                caption='Date Begin'
                width='200px'
                sorted='DateBegin'
                dataType='string'
                index={3}
              />
              <ReactGridColumn
                tagName='column'
                caption='Date End'
                width='200px'
                sorted='DateEnd'
                dataType='string'
                index={4}
              />
              <ReactGridColumn
                tagName='column'
                caption='Resporg'
                width='125px'
                sorted='RESPORG_NAME'
                dataType='string'
                index={5}
              />
              <ReactGridColumn
                tagName='column'
                caption='Resporg Type'
                width='200px'
                sorted='RESPORG_TYPE_NAME'
                dataType='string'
                index={6}
              />
              <ReactGridColumn
                tagName='column'
                caption='Active'
                width='100px'
                sorted='Active'
                dataType='string'
                index={7}
              />
              <ReactGridColumn
                index={8}
                tagName='column'
                caption=''
                width='auto'
              />
            </ReactGridHeader>
            <ReactGridBody tagName="body">
              <ReactGridRowTemplate tagName='rowTemplate'>
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='200px'
                  align='left'
                  column='Company'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='75px'
                  align='center'
                  column='batch'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='200px'
                  align='left'
                  column='numdialed'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='200px'
                  align='left'
                  column='DateBegin'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='200px'
                  align='left'
                  column='DateEnd'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='125px'
                  align='center'
                  column='RESPORG_NAME'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='200px'
                  align='center'
                  column='RESPORG_TYPE_NAME'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  width='100px'
                  align='center'
                  column='Active'
                />
                <ReactGridReadOnlyCell
                  tagName='readOnlyCell'
                  column=''
                  width='auto'
                />
              </ReactGridRowTemplate>
              <ReactGridNoRowsTemplate tagName='noRowTemplate' height='50px'>
                <NoSearchResults caption='There are no wholesale numbers.'/>
              </ReactGridNoRowsTemplate>
            </ReactGridBody>
          </ReactGrid>
          {
            this.renderPagination()
          }
        </span>
      </span>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleNumbers ) );


// WEBPACK FOOTER //
// ./src/content/wholesale/numbers/components/WholesaleNumbers.js